module.exports = __webpack_public_path__ + "static/media/55_000077.3643a070.jpg";